module.exports = __webpack_public_path__ + "static/privacidade-esquema-febbdc97b58eb19e19d28b18b1fd65d4.png";